// extracted by mini-css-extract-plugin
export default {"customOption":"Option_customOption__zJEpY"};